/* ==========================================================================
   assets/spa-cart.js
   Actualizador UI para Carrito en Arquitectura SPA (Modificado)
   ========================================================================== */

// Cambiamos 'submit' por tu evento personalizado 'cart:change'
document.addEventListener('cart:change', async (e) => {
  // Ya no interceptamos el submit ni hacemos el POST, product-form.js ya hizo el trabajo duro y seguro.

  try {
    // 1. Descargar la página actual en segundo plano para obtener el HTML fresco
    const pageResponse = await fetch(window.location.href);
    const htmlText = await pageResponse.text();
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(htmlText, 'text/html');

    // 2. Actualizar la ventana flotante del carrito de tu Custom Header Y2K
    const currentCartWindow = document.getElementById('ch-cart-window');
    const newCartWindow = newDoc.getElementById('ch-cart-window');
    if (currentCartWindow && newCartWindow) {
      currentCartWindow.innerHTML = newCartWindow.innerHTML;
    }

    // 3. Actualizar el numerito rojo/contador del carrito del reproductor
    const currentCounters = document.querySelectorAll('.ch-cart-count');
    const newCounter = newDoc.querySelector('.ch-cart-count');
    if (newCounter) {
      currentCounters.forEach(counter => {
        counter.innerText = newCounter.innerText;
      });
    }

    // 4. Simular un clic en el botón del carrito para abrir tu ventana personalizada
    const btnCart = document.getElementById('ch-btn-cart');
    if (btnCart) {
      btnCart.click();
    }

    // 5. (Opcional de Respaldo) Actualizar Drawer nativo si existe
    const currentDrawer = document.querySelector('cart-drawer');
    const newDrawer = newDoc.querySelector('cart-drawer');
    if (currentDrawer && newDrawer) {
      currentDrawer.replaceWith(newDrawer); 
      const revivedDrawer = document.querySelector('cart-drawer');
      if(revivedDrawer) revivedDrawer.classList.add('is-active');
      document.body.classList.add('overflow-hidden');
    }

  } catch (error) {
    console.error('Error actualizando la interfaz del SPA Cart:', error);
  } 
});